
import { Component, Vue, Watch } from "vue-property-decorator";
import Editor from "@/components/editor.vue";
import { apiModelGetConfig, apiModelSetConfig } from "@/api/model.ts";
@Component({
  components: {
    Editor,
  },
})
export default class ListsDetail extends Vue {
  /** S Data **/
  model_supply_up_agree_zh_cn: string = "";
  model_supply_up_agree_en: string = "";
  /** E Data **/

  /** S Methods **/
  // 点击表单提交
  onSubmit() {
    apiModelSetConfig({
      model_supply_up_agree_zh_cn: this.model_supply_up_agree_zh_cn,
      model_supply_up_agree_en: this.model_supply_up_agree_en,
    }).then((res) => {});
  }

  /** E Methods **/

  /** S Life Cycle **/
  created() {
    apiModelGetConfig({}).then((res) => {
      this.model_supply_up_agree_zh_cn = res.model_supply_up_agree_zh_cn;
      this.model_supply_up_agree_en = res.model_supply_up_agree_en;
    });
  }
  /** E Life Cycle **/
}
